import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../ButtonAction';
import ModalContainer from '../../ModalContainer';
import {toAbsoluteUrl} from '../../../../../../_metronic/_helpers';
import styles from './styles.module.scss';
import classnames from 'classnames';

const GlobalMessage = ({
                         showGlobalMessage,
                         hideGlobalMessage,
                         type,
                         message = 'משהו השתבש. נסה שוב מאוחר יותר...',
                       }) => {

  const getTypeProps = () => {
    switch (type) {
      case 'success':
        return {
          border: styles.borderSuccess,
          button: 'success',
          icon: toAbsoluteUrl('/media/common/Check_circle_green.svg')
        };
      case 'error':
        return {
          border: styles.borderError,
          button: 'error',
          icon: toAbsoluteUrl('/media/common/Cross_circle_red.svg')
        };
      case 'warning':
      default:
        return {
          border: styles.borderWarning,
          button: 'warning',
          icon: toAbsoluteUrl('/media/common/Warning_circle_orange.svg')
        };
    }
  };

  return (
    <ModalContainer
      show={showGlobalMessage} onHide={hideGlobalMessage} size={'md'}
    >
      <div className={classnames('d-flex flex-column align-items-center p-10', getTypeProps().border)}>
        <img src={getTypeProps().icon} alt="icon" className="mb-8 w-75px"/>
        <h2 className="font-weight-bold text-center mb-8">
          {message}
        </h2>
        <ButtonAction
          variant={getTypeProps().button}
          onClick={hideGlobalMessage}
          label={<FormattedMessage id="button-close" defaultMessage="Close"/>}
          customClassnames={'w-150px h-60px'}
        />
      </div>
    </ModalContainer>
  );
};

export default GlobalMessage;
